import { withPrefix } from 'gatsby'
import PropTypes from 'prop-types'
import React, { useEffect, useRef, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import errorSound from '../assets/sounds/error.mp3'
import successSound from '../assets/sounds/positive8.mp3'
import { pickRandom } from '../js/utils'
import { StyledOutlineButton } from '../styles/StyledButtons'
import { StyledKCSA } from '../styles/StyledKC'

const TriviaGameQuestions = React.memo(
  ({
    data,
    docsHidden,
    max,
    ppq,
    reset,
    setDocsHidden,
    setScore,
    setPlaying,
    score,
  }) => {
    const [activeQuestion, setActiveQuestion] = useState(0)
    const [cheater, setCheater] = useState(false)
    const [gameQuestions, setGameQuestions] = useState([])
    const [loading, setLoading] = useState(false)
    const [questionCount, setQuestionCount] = useState(0)
    const [selectedOption, setSelectedOption] = useState('')
    const [sounds, setSounds] = useState({})
    const [trivia, setTrivia] = useState([])
    const myRef = useRef(null)

    useEffect(() => {
      setSounds({
        correct: new Audio(successSound),
        incorrect: new Audio(errorSound),
      })
    }, [])

    useEffect(() => {
      fetch(withPrefix(`/data/eme6208/${data}`))
        .then(res => res.json())
        .then(json => setTrivia(json.trivia))
    }, [])

    useEffect(() => {
      setGameQuestions(pickRandom(trivia, max ? max : trivia.length))
      setQuestionCount(max ? max : trivia.length)
    }, [trivia])

    const handleOptionChange = (e, correct) => {
      setSelectedOption(e.target.id)

      if (e.target.id === correct) {
        setScore(score + ppq)
        sounds.correct.play()
      } else {
        setTimeout(() => {
          if (myRef.current !== null) {
            myRef.current.style.backgroundColor = 'var(--color-green-400)'
            myRef.current.style.color = 'var(--color-white)'
          }
        }, 0)
        sounds.incorrect.play()
      }

      if (activeQuestion < questionCount - 1) {
        setLoading(true)
        setTimeout(() => {
          setActiveQuestion(activeQuestion + 1)
          setSelectedOption('')
          setLoading(false)
        }, 3000)
      } else {
        setSelectedOption('')
        setPlaying(false)
        console.log('GAME OVER')
      }
    }

    const Option = ({ correct, item, loading }) => (
      <div>
        <input
          checked={selectedOption === item}
          className="visually-hidden"
          id={item}
          name="kc-trivia-name"
          onChange={e => handleOptionChange(e, correct)}
          style={{
            pointerEvents: `${loading}` ? 'none' : 'auto',
          }}
          disabled={loading}
          type="radio"
        />
        <label
          className={
            item === correct ? `success${cheater ? ' cheater' : ''}` : 'error'
          }
          htmlFor={item}
          ref={item === correct ? myRef : null}
        >
          {item}
        </label>
      </div>
    )

    if (!gameQuestions.length || gameQuestions.includes(undefined)) {
      return <p>loading...</p>
    }

    return (
      <>
        <StyledKCSA>
          {gameQuestions.map((q, i) => {
            const { correct, options, question } = q
            if (i === activeQuestion) {
              return (
                <div key={uuidv4()}>
                  <p className="statement">{question}</p>
                  {options.map(item => (
                    <Option
                      correct={correct}
                      item={item}
                      key={uuidv4()}
                      loading={loading}
                    />
                  ))}
                  <div className="question-metadata">
                    <p>
                      {loading
                        ? 'Loading next question...'
                        : `Question ${activeQuestion + 1} of ${
                            max ? max : trivia.length
                          }`}
                    </p>
                    <div>
                      <StyledOutlineButton
                        onClick={() => {
                          setActiveQuestion(0)
                          reset()
                        }}
                      >
                        Start Over
                      </StyledOutlineButton>
                      <StyledOutlineButton onClick={() => setCheater(!cheater)}>
                        🤪 Cheat Mode {cheater ? '✔️' : '⬜'}
                      </StyledOutlineButton>
                      <StyledOutlineButton
                        onClick={() => setDocsHidden(!docsHidden)}
                      >
                        Docs {docsHidden ? '⬜' : '✔️'}
                      </StyledOutlineButton>
                    </div>
                  </div>
                </div>
              )
            }
            return null
          })}
        </StyledKCSA>
      </>
    )
  }
)

TriviaGameQuestions.propTypes = {
  correct: PropTypes.bool,
  data: PropTypes.string.isRequired,
  docsHidden: PropTypes.bool,
  item: PropTypes.string,
  loading: PropTypes.bool,
  max: PropTypes.number,
  ppq: PropTypes.number,
  reset: PropTypes.func.isRequired,
  score: PropTypes.number,
  setDocsHidden: PropTypes.func,
  setPlaying: PropTypes.func.isRequired,
  setScore: PropTypes.func.isRequired,
}

TriviaGameQuestions.defaultProps = {
  ppq: 1,
  score: 0,
}

export default TriviaGameQuestions
